/**
 * Coupon Service
 * Handles coupon/discount code validation
 */

import { customersApiClient } from './apiClient';

const DISCOUNT_CODES_VALIDATE_ENDPOINT = '/config/discount-codes/validate';
const DISCOUNT_CODE_VALID_KEY = 'discount_code_valid';

export const couponService = {
  /**
   * Validate a coupon code
   * @param {string} code - Coupon code to validate
   * @param {number} amount - Order amount in cents
   */
  async validateCoupon(code, amount) {
    const result = await customersApiClient.postJson(DISCOUNT_CODES_VALIDATE_ENDPOINT, {
      code,
      amount,
    });

    if (!result.success) {
      return {
        success: false,
        data: null,
        error: result.error || 'Failed to validate coupon',
        isValid: false,
      };
    }

    const isValid = result.key === DISCOUNT_CODE_VALID_KEY;

    if (!isValid) {
      return {
        success: true,
        data: result.data,
        error: result.message || 'Invalid or expired coupon',
        isValid: false,
      };
    }

    return {
      success: true,
      data: result.data,
      error: null,
      isValid: true,
    };
  },
};

export default couponService;
